import ApiBase from '../api-base'
import {ACTIVE_BASE_REST} from '../constants'
export default class PostCategory extends ApiBase {
    constructor (store) {
        const path = ACTIVE_BASE_REST + '/blog/postCategory'
        super(store, path)
    }
}
